import { usePost, useAuth } from "@onefront/react-sdk";
import { generateHeaders } from "../../../utils/generate-headers";

interface IParamsFetch {
    params?: any;
    headers?: any;
    data: { intermediaryId: string };
}

interface IusePostWorkspaceIntermediary {
    (tenantItemId?: string, workspaceId?: string, params?: any | object, lazy?: boolean): {
        data?: null;
        loading?: boolean;
        fetch: (fetchConfig: IParamsFetch) => Promise<any>;
        error: boolean;
    };
}

export const usePostWorkspaceIntermediary: IusePostWorkspaceIntermediary = (
    tenantItemId,
    workspaceId,
    params = {},
    lazy = true
) => {
    return usePost(
        `rnd:core:workspace-write:api://v1/workspaces/${workspaceId}/intermediary`,
        {},
        {
            params: {
                ...params
            },
            headers: generateHeaders(useAuth(), tenantItemId, tenantItemId),
            lazy
        }
    );
};
